<div class="pl-[18px] pr-[68px]">
  <div class="rounded-lg --skelet-bg h-6 mb-6 mt-4" />
</div>
